import { AnimationDefinition, motion } from "framer-motion";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import { bonusTextVariant } from "../utils";

interface MegaShareBonusTextProps extends PropsWithClassName {
  zIndex: number;
  onAnimationComplete: (definition: AnimationDefinition) => void;
}

const MegaShareBonusText = ({ className, zIndex, onAnimationComplete }: MegaShareBonusTextProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={cn("absolute top-[25px] w-fit", className)}
      style={{ zIndex }}
      variants={bonusTextVariant}
      onAnimationComplete={onAnimationComplete}
    >
      <div className="relative w-fit">
        <div
          className={cn(
            "w-fit",
            "rounded-[5px]",
            "bg-[linear-gradient(180deg,#FDC135_21.54%,#EFDD75_86.12%)]",
            "px-[6px] pb-1 pt-[5px]",
            "flex items-center justify-center",
            "whitespace-nowrap text-[12px] font-bold uppercase",
            "relative z-10",
          )}
          style={{
            fontFamily: "Noto Sans Thai",
            color: "var(--Components-DownloadBar-Bg, #0C0629)",
          }}
        >
          {t("you got a gift")}
        </div>

        <img
          src="/images/mega-share/triangle-down.png"
          alt=""
          className={cn("absolute start-1/2 -translate-start-1/2", "bottom-[-7px]", "h-[10px] w-[18px]")}
        />
      </div>
    </motion.div>
  );
};

export default MegaShareBonusText;
